import { css } from 'styled-components';

import theme from './theme';

export const headingFont = css`
  font-family: ${theme.fonts.heading};
  line-height: 1.1;
  letter-spacing: -0.02em;
`;
